module.exports = __webpack_public_path__ + "static/media/coupon03_ja.a71f2255.png";